import { useAuth } from '@/contexts/AuthContext';
import { ReactNode } from 'react';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoading } = useAuth();

  if (isLoading) return null;

  return <>{children}</>;
}
